export type RemoteVersionVerdict = 'ignore' | 'defer' | 'conflict'

interface RemoteVersionInput {
  /** draftVersion reported by a shareDocletUpdated event or a version check. */
  remoteVersion: number
  /** The latest draftVersion this builder has saved or loaded. */
  knownVersion: number
  /** Whether this builder has a save in flight right now. */
  saveInFlight: boolean
}

/**
 * Decide whether a draftVersion seen from the server means someone else has
 * saved over this builder's draft.
 *
 * Events for this builder's own saves come back too, and can arrive before
 * the save's own response. So while a save is in flight the answer is
 * 'defer': once the response says which version this builder produced, run
 * this again with that as knownVersion. Anything at or below knownVersion is
 * this builder's own save (or old news); anything above is someone else's --
 * including this person's own second tab, which is deliberately treated as
 * another editor.
 */
export const classifyRemoteVersion = ({
  remoteVersion,
  knownVersion,
  saveInFlight
}: RemoteVersionInput): RemoteVersionVerdict => {
  if (saveInFlight) return 'defer'
  return remoteVersion > knownVersion ? 'conflict' : 'ignore'
}
